import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IStoreState } from "../initialStoreState";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../messages/messagesActions";
import { ICourse, IOrganization, ISession } from "./type";
import { defaultSessionInfo } from "./default";

export const FETCH_ORGANIZATIONS_PROGRESS = "FETCH_ORGANIZATIONS_PROGRESS";
export const FETCH_ORGANIZATIONS_SUCCESS = "FETCH_ORGANIZATIONS_SUCCESS";
export const FETCH_ORGANIZATIONS_FAILED = "FETCH_ORGANIZATIONS_FAILED";

export const fetchOrganizationProgress = () =>
  action(FETCH_ORGANIZATIONS_PROGRESS);
export const fetchOrganizationSuccess = (data: IOrganization[], totalRecords: number,singleOrganization: IOrganization) =>
  action(FETCH_ORGANIZATIONS_SUCCESS, { data,totalRecords,singleOrganization });
export const fetchOrganizationFailed = (errorMessage: string) =>
  action(FETCH_ORGANIZATIONS_FAILED,{errorMessage});

export const fetchOrganizationAsync =
  (
   pageNo?: number|null,
   itemPerPage?: number|null,
   organizationUUID?:string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchOrganizationProgress());

let url =""
if(organizationUUID){
  url+= `&organizations_uuid=${organizationUUID}`
}


      const res = await api.get(
        `master/get-organizations?pageNo=${pageNo}&itemPerPage=${itemPerPage}`+url
      );

      const data: IOrganization[] = res.data.data;
      const singleData= res.data.data

      dispatch(fetchOrganizationSuccess(data , res.data.totalRecords, singleData[0]));
    } catch (err: any) {
      dispatch(fetchOrganizationFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };


  export const upsertOrganzationAsync =(existingLead:IOrganization, onCallBack:(isSuccess?:boolean, data?: IOrganization) => void):ThunkAction<void, IStoreState, {}, AnyAction>=> async(dispatch, getState) =>{
    dispatch(saveLoaderProgress());
      try {
        const {organizations_unique_id,organizations_id,modified_by_name,modified_by_uuid,create_ts,created_by_name,created_by_uuid,insert_ts,...rest} = existingLead;
        const res = await api.post("/master/upsert-organizations", rest);
        dispatch(
          showMessage({
            type: "success",
            message: "Organization is saved succesfully!",
            displayAs: "snackbar",
          })
        );
        const data = res.data.data;
        onCallBack(true, data);
      } catch (err: any) {
        onCallBack(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }finally{
        dispatch(saveLoaderCompleted());
      }
    };


export const FETCH_COURSE_PROGRESS = "FETCH_COURSE_PROGRESS";
export const FETCH_COURSE_SUCCESS = "FETCH_COURSE_SUCCESS";
export const FETCH_COURSE_FAILED = "FETCH_COURSE_FAILED";
export const fetchCourseProgress = () =>
  action(FETCH_COURSE_PROGRESS);
export const fetchCourseSuccess = (data: ICourse[],totalRecords: number, singleCourse: ICourse ) =>
  action(FETCH_COURSE_SUCCESS, { data,totalRecords,singleCourse });
export const fetchCourseFailed = (errorMessage: string) =>
  action(FETCH_COURSE_FAILED,{errorMessage});

export const fetchCourseAsync =
  (
    organizationUUID: string,
    pageNo: number,
    itemPerPage: number
   
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCourseProgress());
      const res = await api.get(
        `/master/get-courses?pageNo=${pageNo}&itemPerPage=${itemPerPage}&organizations_uuid=${organizationUUID}&status=ACTIVE`
      );

      const data: ICourse[] = res.data.data;
const singleData= res.data.data
      dispatch(fetchCourseSuccess(data , res.data.totalRecords, singleData[0]));
    } catch (err: any) {
      dispatch(fetchCourseFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  export const upsertCourseAsync =(existingLead:ICourse, onCallBack:(isSuccess?:boolean, data?: ICourse) => void):ThunkAction<void, IStoreState, {}, AnyAction>=> async(dispatch, getState) =>{
    dispatch(saveLoaderProgress());
      try {
        const {modified_by_name,modified_by_uuid,create_ts,created_by_name,created_by_uuid,insert_ts,courses_unique_id,courses_id,session_duration_in_years,session_info_uuid,session_name,...rest} = existingLead;
        const res = await api.post("/master/upsert-courses", rest);
        dispatch(
          showMessage({
            type: "success",
            message: "Course is saved succesfully!",
            displayAs: "snackbar",
          })
        );
        const data = res.data.data;
        onCallBack(true, data);
      } catch (err: any) {
        onCallBack(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }finally{
        dispatch(saveLoaderCompleted());
      }
    };


// export const CLEAR_COURSE_LIST = "CLEAR_COURSE_LIST";
// export const clearCourse = () => action(CLEAR_COURSE_LIST);

export const FETCH_SESSION_LIST_PROGRESS = "FETCH_SESSION_LIST_PROGRESS";
export const FETCH_SESSION_LIST_SUCCESS = "FETCH_SESSION_LIST_SUCCESS";
export const FETCH_SESSION_LIST_FAILED = "FETCH_SESSION_LIST_FAILED";
export const fetchSessionListProgress = () =>
  action(FETCH_SESSION_LIST_PROGRESS);
export const fetchSessionListSuccess = (data: ISession[],totalRecords: number ) =>
  action(FETCH_SESSION_LIST_SUCCESS, { data,totalRecords });
export const fetchSessionListFailed = (errorMessage: string) =>
  action(FETCH_SESSION_LIST_FAILED,{errorMessage});

export const fetchSessionListAsync =
  (

    pageNo: number,
    itemPerPage: number,

   
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {

      let url =""
      
      dispatch(fetchSessionListProgress());
      const res = await api.get(
        `/master/get-session?pageNo=${pageNo}&itemPerPage=${itemPerPage}`+url
      );

      const data: ISession[] = res.data.data;

      dispatch(fetchSessionListSuccess(data , res.data.totalRecords));
    } catch (err: any) {
      dispatch(fetchSessionListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };


  export const FETCH_SESSION_PROGRESS = "FETCH_SESSION_PROGRESS";
export const FETCH_SESSION_SUCCESS = "FETCH_SESSION_SUCCESS";
export const FETCH_SESSION_FAILED = "FETCH_SESSION_FAILED";
export const fetchSessionProgress = () =>
  action(FETCH_SESSION_PROGRESS);
export const fetchSessionSuccess = ( data: ISession ) =>
  action(FETCH_SESSION_SUCCESS, { data });
export const fetchSessionFailed = (errorMessage: string) =>
  action(FETCH_SESSION_FAILED,{errorMessage});

export const fetchSessionAsync =
  (


    sessionUUID?:string,
   
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {

      dispatch(saveLoaderProgress());
      dispatch(fetchSessionProgress());
      const res = await api.get(
        `/master/get-session?session_info_uuid=${sessionUUID}`
      );

const data= res.data.data
      dispatch(fetchSessionSuccess( data[0]));
    } catch (err: any) {
      dispatch(fetchSessionFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
    finally{
      dispatch(saveLoaderCompleted());
    }
  };


  export const upsertSessionAsync =(existingLead:ISession, onCallBack:(isSuccess:boolean, data: ISession) => void):ThunkAction<void, IStoreState, {}, AnyAction>=> async(dispatch, getState) =>{
    dispatch(saveLoaderProgress());
      try {
        const {modified_by_name,modified_by_uuid,create_ts,created_by_name,created_by_uuid,insert_ts,session_info_id,session_info_unique_id,...rest} = existingLead;
        const res = await api.post("/master/upsert-session", rest);
        dispatch(
          showMessage({
            type: "success",
            message: "Session is saved succesfully!",
            displayAs: "snackbar",
          })
        );
        const data = res.data.data;
        onCallBack(true, data);
      } catch (err: any) {
        onCallBack(false,defaultSessionInfo);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }finally{
        dispatch(saveLoaderCompleted());
      }
    };


    export const CLEAR_MASTER_STATE = "CLEAR_MASTER_STATE";
    export const CLEAR_MASTER_ORGANIZATION = "CLEAR_MASTER_ORGANIZATION";
    export const CLEAR_MASTER_COURSE = "CLEAR_MASTER_COURSE";
    export const CLEAR_MASTER_SESSION = "CLEAR_MASTER_SESSION";
    
    export const clearMasterState = () => action(CLEAR_MASTER_STATE);
    export const clearMasterOrganization = () => action(CLEAR_MASTER_ORGANIZATION);
    export const clearMasterCourse = () => action(CLEAR_MASTER_COURSE);
    export const clearMasterSession = () => action(CLEAR_MASTER_SESSION);
